<template>
  <v-chip
    v-if="scr"
    :color="chipColor"
    :text-color="chipTextColor"
    small
    class="cke-badge ml-2"
    :title="tooltipText"
  >
    <v-icon left small>mdi-credit-card-outline</v-icon>
    <span class="font-weight-medium">CKE</span>
    <span v-if="showCardNumber" class="ml-1">{{ scr.card_number_formatted || scr.card_number }}</span>
    <v-icon v-if="statusIcon" right small>{{ statusIcon }}</v-icon>
  </v-chip>
</template>

<style scoped>
.cke-badge {
  cursor: default;
}
</style>

<script>
export default {
  name: 'CkeBadge',
  props: {
    scr: {
      type: Object,
      default: null
    },
    showCardNumber: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chipColor () {
      if (!this.scr) { return 'grey lighten-2' }
      switch (this.scr.card_status) {
        case 'ACTIVE': return 'green lighten-4'
        case 'EXPIRED': return 'orange lighten-4'
        case 'BLOCKED': return 'red lighten-4'
        default: return 'grey lighten-2'
      }
    },
    chipTextColor () {
      if (!this.scr) { return 'grey darken-2' }
      switch (this.scr.card_status) {
        case 'ACTIVE': return 'green darken-3'
        case 'EXPIRED': return 'orange darken-3'
        case 'BLOCKED': return 'red darken-3'
        default: return 'grey darken-2'
      }
    },
    statusIcon () {
      if (!this.scr) { return null }
      switch (this.scr.card_status) {
        case 'ACTIVE': return 'mdi-check-circle'
        case 'EXPIRED': return 'mdi-alert-circle'
        case 'BLOCKED': return 'mdi-close-circle'
        default: return null
      }
    },
    cardStatusText () {
      if (!this.scr?.card_status) { return '' }
      switch (this.scr.card_status.toUpperCase()) {
        case 'ACTIVE': return 'Aktivt'
        case 'EXPIRED': return 'Utgånget'
        case 'BLOCKED': return 'Spärrat'
        case 'AWAITS_ACTIVATING': return 'Väntar på aktivering'
        case 'AWAITS_ORDERING': return 'Väntar på beställning'
        case 'RENEW': return 'Förnya'
        case 'REPLACE': return 'Ersätt'
        case 'INACTIVE': return 'Inaktivt'
        default: return this.scr.card_status
      }
    },
    tooltipText () {
      if (!this.scr) { return '' }
      const parts = ['Camping Key Europe']
      if (this.scr.card_status) { parts.push(`Status: ${this.cardStatusText}`) }
      if (this.scr.card_expires_at) { parts.push(`Giltig t.o.m: ${this.scr.card_expires_at}`) }
      if (this.scr.needs_renewal) { parts.push('⚠ Behöver förnyas') }
      return parts.join('\n')
    }
  }
}
</script>
